import { TextBox } from '@apply/components';
import { useCustomPaymentAddressStreet2 } from '../../../../../fields/CustomPaymentFields';

interface StreetAddress2Props {
    customPaymentId: string;
    required?: boolean;
    validator?: React.ReactNode;
}

export const StreetAddress2: React.FC<StreetAddress2Props> = ({ customPaymentId, required = false, validator }) => {
    const label = 'Street Address (cont.)';
    const [streetAddress2, set_streetAddress2] = useCustomPaymentAddressStreet2(customPaymentId);
    return (
        <>
            <TextBox
                id='streetAddress2'
                value={streetAddress2}
                onChange={(value) => set_streetAddress2(value)}
                placeholder='Suite 123'
                required={required}
                width='100%'
                maxLength={50}
                validator={validator}
                label={label}
            />
        </>
    );
};
